import { GridInitialStatePro } from '@mui/x-data-grid-pro/models/gridStatePro';
import { GridPreferences, gridInitialState } from '../../../store/User';
import { GroupedGridColDef } from '../UpstackDataGrid/gridColumnTypes';

export const buildGridSettings = (columns: GroupedGridColDef[]): GridPreferences => ({
  muiConfig: gridInitialState(columns) as GridInitialStatePro,
  disabledFields: []
});
